// extracted by mini-css-extract-plugin
module.exports = {"container":"-JJfifv","bagTitle":"_1vvMfU_"};